import dayjs from "dayjs";

function toAPIDate(data) {
  if (!data) return "";

  return dayjs(data).format("YYYY-MM-DD");
}

function toFullDate(data) {
  if (!data) return "";

  return dayjs(data).format("DD MMMM YYYY");
}

function toFullDateTime(data) {
  if (!data) return "";

  return dayjs(data).format("DD MMMM YYYY HH:mm:ss");
}

function toShortDate(data) {
  if (!data) return "";

  return dayjs(data).format("DD/MM/YYYY");
}

function toShortMonthYear(data) {
  if (!data) return "";

  return dayjs(data).format("MMM/YYYY");
}

function toShortMonth(data) {
  if (!data) return "";

  return dayjs(data).format("MM");
}

function toShortYear(data) {
  if (!data) return "";

  return dayjs(data).format("YYYY");
}

function toObjectDayJs(data) {
  if (!data) return Date.now();

  return dayjs(data);
}

function toYearMonthDuration(totalDays) {
  const years = Math.floor(totalDays / 365);
  const months = Math.floor((totalDays % 365) / 30);
  const days = totalDays;

  const yearsDisplay = `${years}y`;
  const monthsDisplay = `${months}m`;
  const daysDisplay = `${days}d`;

  return !years && !months ? daysDisplay : `${yearsDisplay} ${monthsDisplay}`;
}

function toFullDateTimeWithMonthName(data) {
  if (!data) return "";

  return dayjs(data).format("MMMM D, YYYY h:mmA");
}

export const formatDate = {
  toAPIDate,
  toFullDate,
  toFullDateTime,
  toShortDate,
  toShortMonth,
  toShortMonthYear,
  toShortYear,
  toObjectDayJs,
  toYearMonthDuration,
  toFullDateTimeWithMonthName,
};
